import React from 'react';
import PropTypes from 'prop-types';

import SETTINGS from '../settings';

const url = (key, frmt, type, opts = '') => {
  let path = key;
  if (type != null) {
    const arr = path.split('/');
    arr.splice(arr.length - 1, 0, type);

    path = arr.join('/');
  }

  return `${SETTINGS.CLOUDINARY_ROOT_URL}/${path}${opts}.${frmt}`;
};

const CloudinaryPicture = props => {
  const altText = SETTINGS.CLOUDINARY_ALT_TEXTS[props.imageKey] ?? '';
  // there is difference between props.imageKey and real imageKey
  // it's due to images.json generator
  // TODO don't remove prefix in images.json generator, and then we don't need any prefix and differences
  const imageKey = `${props.prefix}${props.imageKey}`;

  return (
    <picture>
      <source
        type="image/webp"
        srcSet={
          (url(imageKey, 'webp', props.type), `${url(imageKey, 'webp', props.type, '@2x')} 2x`)
        }
      />

      <source
        type="image/jp2"
        srcSet={(url(imageKey, 'jp2', props.type), `${url(imageKey, 'jp2', props.type, '@2x')} 2x`)}
      />

      <source
        type="image/vnd.ms-photo"
        srcSet={(url(imageKey, 'jxr', props.type), `${url(imageKey, 'jxr', props.type, '@2x')} 2x`)}
      />

      <img
        alt={altText}
        title={altText}
        src={url(imageKey, 'jpg', props.type)}
        className={props.className}
        srcSet={url(imageKey, 'jpg', props.type, '@2x')}
        style={props.style}
      />
    </picture>
  );
};

CloudinaryPicture.propTypes = {
  prefix: PropTypes.string,
  imageKey: PropTypes.string,
  type: PropTypes.oneOf(['big', 'small']),
  className: PropTypes.string,
  style: PropTypes.object,
};

CloudinaryPicture.defaultProps = {
  prefix: '',
};

export default CloudinaryPicture;
